import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { AppThemeProvider } from "@/AppThemeProvider";
import { AuthProvider, useUser } from "@/auth/AuthProvider";
import { GateGate } from "@/auth/GateGate";
import { queryClient } from "@/queryClient";
import { router } from "@/router";
import { initSentry } from "@/sentry";

// Sentry initialization — gated behind VITE_SENTRY_DSN; release = git SHA.
// Source-map upload is wired in CI (see infra / frontend build).
void initSentry();

/**
 * Inner component that reads user context and passes it to the router.
 * Must be inside <AuthProvider> so useUser() works.
 */
function RouterWithAuth() {
  const user = useUser();
  return <RouterProvider router={router} context={{ user }} />;
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <AppThemeProvider>
      <GateGate>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <RouterWithAuth />
          </QueryClientProvider>
        </AuthProvider>
      </GateGate>
    </AppThemeProvider>
  </StrictMode>,
);
